const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'propertiesForms',
		'componentDataForm'
	],

	config: {
		componentDataDependentFieldAssociation: false,
		simpleSubForm: true
	},

	model: {
		segmentationValueComponentDataFormFieldsReady: false
	},

	methods: {
		dataDealer: function(){
			// load field data manually
			var self = this;
			if(!self.model.segmentationValueComponentDataFormFieldsReady){
				self.model.additionalDataComponent = self.getResourceRegisterContent('additionalDataComponent');
				if(self.model.additionalDataComponent) {
					self.model.segmentationValueComponentDataFormFieldsReady = true;

					self.initComponentData(self.model.additionalDataComponent);
					utils.promise.performAllChains(self, self.getPostBuildFieldActions()).then(function (fieldData) {
						if (self.$) {
							self.refresh(false);
							self.triggerClosest('segmentationValueComponentDataFormReady');
						}
					});
				}
			}
		},

		fieldToModel: function(fieldCode, fieldValue, forceModelFieldValueChange, dependencyCall){
			this.triggerClosest('onChildChanged', {
				renderedFieldCode: fieldCode,
				value: fieldValue
			});
		}
	}
};
